/*********************************************************************************************
 * Initialize Lenis for smooth scrolling.
 *
 * Ce fichier n'utilise plus GSAP : le registerPlugin qui figurait ici a ete retire
 * en meme temps que le bloc SplitText mort. GSAP n'etant plus charge globalement
 * (seule MM-Steps le charge, cf. snippets/scripts.liquid), l'appel aurait leve une
 * ReferenceError sur toutes les pages sans cette section.
 */

// Désactive Lenis (smooth scroll JS) sur tablette/mobile et tout appareil tactile :
// le scroll natif tactile entre en conflit avec Lenis (scroll saccadé / sauts).
const isTouch = window.matchMedia("(pointer: coarse)").matches || "ontouchstart" in window;
const isMobile = window.innerWidth < 1025 || isTouch;

let lenis; // Ajouté en haut du fichier pour la portée globale
let lenisShouldBeStopped = false;

// Disable Lenis when overing div with overflow:scroll
function stopLenis() {
	if (!isMobile) {
		lenisShouldBeStopped = true;
		document.querySelector("html").classList.add("stop-scrolling");
		lenis?.destroy();
	}
}

// Fonction appelée quand la souris quitte l'élément
function startLenis() {
	// Lib pas encore chargee (injectee cote client) : demarrage sur global:lenis-ready
	if (typeof Lenis === "undefined") return;
	if (!isMobile) {
		lenisShouldBeStopped = false;
		if (lenis) {
			lenis.destroy();
		}
		lenis = new Lenis({
			lerp: 0.12,
			wheelMultiplier: 1,
			smoothTouch: true,
			touchMultiplier: 1,
			autoResize: true,
			smooth: true,
			gestureOrientation: "vertical",
			smoothWheel: true,
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);

		document.querySelector("html").classList.remove("stop-scrolling");
	}
}

// Expose globally so snippets peuvent contrôler Lenis
if (!isMobile) {
    window.stopLenis = stopLenis;
    window.startLenis = startLenis;
}

function setupLenis() {
	var elements = document.querySelectorAll(".stop-lenis");
	lenisShouldBeStopped = false;

	elements.forEach(function (element) {
		if (!isMobile) {
			element.addEventListener("mouseenter", stopLenis);
			element.addEventListener("mouseleave", startLenis);
		}
	});
}

if (!isMobile) {
	setupLenis();
}

document.querySelectorAll(".mm-btn").forEach((button) => {
	button.addEventListener("click", () => {
		button.classList.add("clicked");

		// Supprime la classe après l'animation pour pouvoir la rejouer à chaque clic
		setTimeout(() => {
			button.classList.remove("clicked");
		}, 750); // Doit correspondre à la durée de l'animation CSS (0.35s)
	});
});

if (!isMobile) {
	// Debounce pour éviter de relancer trop souvent Lenis
	let lenisTimeout;
	const observer = new MutationObserver((mutationsList, observer) => {
		if (lenisTimeout) clearTimeout(lenisTimeout);
		lenisTimeout = setTimeout(() => {
			if (!lenisShouldBeStopped) {
				startLenis();
			}
		}, 400); // 400ms après la dernière mutation (limite les recréations de Lenis sur mutations d'apps tierces)
	});

	observer.observe(document.body, { childList: true, subtree: true });
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	if (isMobile) return;
	if (typeof Lenis !== "undefined") startLenis();
	else document.addEventListener("global:lenis-ready", startLenis, { once: true });
});
